import { Account } from 'src/models/account';

export type LoginAccountStateAction =
  | {
      type: 'SET_ITEM';
      payload: Account;
    }
  | {
      type: 'REMOVE_ITEM';
    };

export const loginAccountReducer = (
  state: Account,
  action: LoginAccountStateAction
) => {
  switch (action.type) {
    case 'SET_ITEM':
      return {
        ...action.payload,
      };

    case 'REMOVE_ITEM':
      return state;

    default:
      return state;
  }
};
